/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse
 */
export interface WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse
     */
    checkoutUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse
     */
    id?: string | null;
}

/**
 * Check if a given object implements the WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse interface.
 */
export function instanceOfWebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSON(json: any): WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse {
    return WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSONTyped(json, false);
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkoutUrl': !exists(json, 'checkout_url') ? undefined : json['checkout_url'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponseToJSON(value?: WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkCreatePaymentLinkResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkout_url': value.checkoutUrl,
        'id': value.id,
    };
}

